import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableUserSettings = Loadable({
  loader: function loader() {
    return import('../UserSettings.jsx');
  },
  loading: ComponentLoading
});
export default LoadableUserSettings;